import classNames from 'classnames';
import { bool, func, node, oneOfType, string } from 'prop-types';
import React from 'react';
import css from './FIeldDisabledInput.module.css';

function FieldDisabledInput(props) {
  const {
    id,
    name,
    label,
    value,
    className,
    rootClassName,
    buttonLabel,
    showButton,
    onClick,
    iconClassName,
  } = props;
  const classes = classNames(css.root || rootClassName, className);
  const btnClasses = classNames(css.clickBtn, iconClassName);

  const handleClick = e => {
    e.preventDefault();
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  const isButtonEnabled = showButton && !!buttonLabel && typeof onClick === 'function';
  return (
    <div className={classes} id={id}>
      <div className={css.label}>{label}</div>
      <div className={css.textWrapper}>
        <span className={classNames(css.text, { [css.btnText]: isButtonEnabled })}>{value}</span>
        {isButtonEnabled ? (
          <button type="button" onClick={handleClick} className={btnClasses}>
            {buttonLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}

FieldDisabledInput.defaultProps = {
  className: null,
  rootClassName: null,
  showButton: false,
  buttonLabel: null,
  iconClassName: null,
};

FieldDisabledInput.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  label: oneOfType([string, node]).isRequired,
  buttonLabel: oneOfType([string, node]),
  value: string.isRequired,
  className: string,
  rootClassName: string,
  name: string,
  iconClassName: string,
  showButton: bool.isRequired,
  onClick: func,
};

export default FieldDisabledInput;
